import { ColorVariables } from "manifest-components/src/Colors";
import styled from "styled-components";

export const HenryAssistedFormContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .white-space-nowrap {
    white-space: nowrap;
    font-size: inherit;
    line-height: inherit;
  }
`;
export const HenryAssistedFormHeader = styled.div`
  max-width: 572px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  h2 {
    font-size: 20px;
    line-height: 28px;
    @media (min-width: 769px) {
      font-size: 22px;
      line-height: 32px;
    }

    font-weight: 700;
  }
  p {
    font-size: 14px;
    line-height: 22px;
    @media (min-width: 769px) {
      margin-top: 34px;
      font-size: 16px;
      line-height: 1.5;
    }
  }
  margin-bottom: 12px;
  @media (min-width: 769px) {
    margin-bottom: 46px;
  }
`;

export const HenryAssistedFormMain = styled.div<{
  $isWide?: boolean;
  $maxWidth?: number;
}>`
  flex: 1;
  width: 100%;
  &.iraOpenAction {
    h1 {
      font-size: 24px;
      line-height: 32px;
    }
    .subheading {
      max-width: 300px;
    }
  }
  ${(props) =>
    !props.$isWide &&
    `

@media (min-width: 769px){
  margin-right:auto;
  margin-left:auto;
  width: 576px;
  .clap-button-container{
    width: 576px;
    height: 292px;
    cursor:pointer;
  }
  }
`}
  padding-bottom: 12px;
  @media (min-width: 769px) {
    padding-bottom: 0px;
  }

  .field-error {
    text-align: center;
    color: ${ColorVariables.cherry};
    padding: 8px 0;
  }

  @media (max-width: 768px) {
    .radio-tile__reallocation {
      padding-top: 8px;
      padding-bottom: 8px;
    }
    .radio-tile__content__flex-start {
      align-items: flex-start;
    }
    .radio-tile__title {
      font-size: 14px;
      line-height: 22px;

      &__no-margin {
        margin-bottom: -12px;
      }
    }

    .radio-tile__subtitle {
      font-size: 14px;
      line-height: 22px;
    }
    .radio-tile__radio-div__padding {
      padding-top: 22px;
    }
  }

  @media (min-width: 769px) {
    &.iraOpenAction {
      width: 645px;
      h1 {
        font-size: 36px;
        line-height: 46px;
      }
      .subheading {
        max-width: 623px;
        margin-left: auto;
        margin-right: auto;
      }
    }
    .radio-tile {
      padding-top: 20px;
      padding-bottom: 20px;
      &__subtitle {
        white-space: nowrap;
        margin-bottom: 12px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;

export const HenryAssistedFormTips = styled.div<{ $isWide: boolean }>`
  margin: 0 auto;
  width: 100%;
  max-width: 305px;
  margin-bottom: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  img {
    width: 31px;
    height: 40px;
    margin-right: 6px;
  }
  @media (min-width: 769px) {
    width: 485px;
    margin-bottom: 28px;
    max-width: 485px;
  }
`;

export const HenryAssistedFormFooter = styled.div`
  width: 100%;
  padding-bottom: 30px;

  margin-right: auto;
  margin-left: auto;
  max-width: 576px;
`;

export const ConnectOldAccountWrapper = styled.div`
  height: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  svg {
    margin-right: 8px;
  }

  .connect-button-div {
    align-self: flex-start;
    width: 100%;
    margin: 0 auto;
    background: ${ColorVariables.orange3};
    border-radius: 8px;
    border: 1px solid ${ColorVariables.coco1};
    display: flex;
    padding: 20px;
    &.active {
      padding: 20px;
      border: 1px solid ${ColorVariables.coco3};
      position: relative;
      .provider-name {
        font-weight: 600;
        color: ${ColorVariables.coco};
        line-height: 30px;
      }
      .status {
        color: ${ColorVariables.coco9};
      }

      .remove-button {
        position: absolute;
        top: 20px;
        right: 20px;
        display: flex;
        width: 30px;
        height: 30px;
        justify-content: center;
        align-items: center;
      }
    }
    span {
      margin-right: 12px;
      font-size: 14px;
      line-height: 22px;
    }
    button {
      width: 100px;
      flex: 0 0 100px;
    }

    @media (min-width: 769px) {
      padding: 30px;
      max-width: 540px;
      button {
        width: 112px;
        flex: 0 0 100px;
      }
      span {
        margin-right: 40px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;

export const spaceBetweenFeed = 2;
export const spaceBetweenFeedLG = 4;

export const ChatBubbleWithBackground = styled.div<{ $chatRole: "admin" | "user" }>`
  position: relative;
  margin-top: ${spaceBetweenFeed}px;
  font-size: 14px;
  line-height: 1.57;
  font-weight: 400;
  overflow-wrap: break-word;
  border-radius: 20px;
  color: ${ColorVariables.coco};
  width: auto;
  span {
    padding: 7px 12px;
    display: block;
  }

  ${(props) =>
    props.$chatRole === "admin"
      ? `background: ${ColorVariables.mint1};
`
      : props.$chatRole === "user"
      ? `
      background: ${ColorVariables.coco1};
      text-align:right;
`
      : ""}

  @media (min-width: 768px) {
    margin-top: ${spaceBetweenFeedLG}px;
    font-size: 16px;
    span {
      padding: 9px 13px;
    }
  }
`;
